// Lightweight analytics helper wrapping Plausible custom events.
// Plausible auto-tracks pageviews (incl. SPA via hash script + manual trigger below).

function isProduction(): boolean {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return (
    host === "trendsdiscovery.com" ||
    host === "www.trendsdiscovery.com" ||
    host === "trend-blueprint-ai.lovable.app"
  );
}

type Props = Record<string, string | number | boolean | undefined>;

declare global {
  interface Window {
    plausible?: (
      event: string,
      options?: { props?: Props; callback?: () => void; u?: string }
    ) => void;
  }
}

export const ANALYTICS_EVENTS = {
  SIGN_UP: "Sign Up",
  SIGN_IN: "Sign In",
  SIGN_IN_FAILED: "Sign In Failed",
  PASSWORD_RESET_REQUEST: "Password Reset Requested",
  ONBOARDING_COMPLETED: "Onboarding Completed",
  CHECKOUT_STARTED: "Checkout Started",
  CHECKOUT_SUCCESS: "Checkout Success",
  WATCH_ADDED: "Watch Added",
  ALERT_RULE_CREATED: "Alert Rule Created",
  TREND_VIEWED: "Trend Viewed",
  TREND_ACTION: "Trend Action",
  VALIDATION_RUN: "Validation Check Run",
} as const;

export function trackEvent(event: string, props?: Props) {
  try {
    if (typeof window === "undefined" || !isProduction()) return;
    window.plausible?.(event, props ? { props } : undefined);
  } catch {
    // never break the app for analytics
  }
}

export function trackPageView(url?: string) {
  try {
    if (typeof window === "undefined" || !isProduction()) return;
    window.plausible?.("pageview", url ? { u: url } : undefined);
  } catch {}
}
